export enum UserWhitelistEnums {
    UNKNOWN = 0,
    WHITE,
    BLACK,
}
